import { useEffect, useState } from 'react';

interface PlatformInfo {
    isMobile: boolean;
    isFlutterApp: boolean;
    platform: 'android' | 'ios' | 'web';
}

const usePlatformCheck = (): PlatformInfo => {
    const [platformInfo, setPlatformInfo] = useState<PlatformInfo>({
        isMobile: false,
        isFlutterApp: false,
        platform: 'web',
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const uaString = window.navigator.userAgent.toLowerCase();
            const isMobile = /mobile|android|iphone|ipad|ipod/.test(uaString);
            const isFlutterApp = uaString.includes('flutter');
            const isIos = /applewebkit|safari/.test(uaString);
            const isAndroid = /android/.test(uaString);

            let platform: 'android' | 'ios' | 'web' = 'web';
            if (isFlutterApp && isIos) {
                platform = 'ios';
            } else if (isFlutterApp && isAndroid) {
                platform = 'android';
            }

            setPlatformInfo({
                isMobile,
                isFlutterApp,
                platform,
            });
        }
    }, []);

    return platformInfo;
};

export default usePlatformCheck;